import { useEffect, useCallback } from 'react';
import useApi from './useApi';
import { ProcedureItem } from '../types/ProcedureTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export default (category: number) => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getProcedures = useCallback(async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                throw new Error('API URL not configured in app settings');
            }
            await getApiData({
                endpoint: `${apiUrl}GetProcedures?category=${category}`,
            });
        } catch (error) {
            console.error(`Failed to fetch procedures for category ${category}:`, error);
        }
    }, [getApiData, category]);

    // Get the procedures data
    const getProceduresData = (): ProcedureItem[] => {
        if (state.status === 'success' && state.result) {
            let rawProcedures: any[] = [];
            if (Array.isArray(state.result)) {
                rawProcedures = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                rawProcedures = state.result.data;
            } else if (typeof state.result === 'object') {
                rawProcedures = [state.result];
            }
            return rawProcedures;
        }
        return [];
    };

    return {
        procedures: getProceduresData(),
        loading: state.isLoading,
        error: state.error,
        getProcedures,
        status: state.status,
    };
};
